import React from 'react'
import globals from '../globals'
import LineChart from './LineChart'

class UsageGraphsMobile extends React.Component {
    render () {
        return (
            <div className='usage-historical'>
                <LineChart
                    labels={[...globals.getLastSixMonths()]}
                    data={this.props.usageHistorical.data}
                    unit={this.props.usageHistorical.unit}
                />
            </div>
        )
    }
}

export default UsageGraphsMobile



// WEBPACK FOOTER //
// ./resources/js/components/UsageGraphsMobile.js